import { render } from "./404.vue?vue&type=template&id=66a31f2c&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=66a31f2c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a31f2c"]])

export default __exports__